<template>
  <div class="animated fadeIn">
    <b-card header="Request Incentive Saldo">
      <p v-if="partner">Total Incentive : {{ partner.incentive_saldo | toRupiah }}</p>
      <b-row>
        <b-col md="6" class="mb-3">
          <label for="amount">Amount</label>
          <b-form-input id="amount" v-model="input.amount" name="amount" type="number" min="1" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label for="bank-name">Bank Name</label>
          <b-form-select id="bank-name" v-model="input.bank_name" :options="bankNameOptions" name="bank_name" />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="mb-3">
          <label for="account-number">Account Number</label>
          <b-form-input id="account-number" v-model.trim="input.account_number" name="account_number" type="text" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label for="account-name">Account Name</label>
          <b-form-input id="account-name" v-model.trim="input.account_name" name="account_name" type="text" />
        </b-col>
      </b-row>
      <b-button :disabled="storeState.isProcessing" variant="primary" class="px-4 mt-2" @click="submitRequestIncentives">Submit</b-button>
    </b-card>
  </div>
</template>

<script>
import { store } from '@/shared/store'
import { getPartnerInfo, getAllBanks, requestIncentiveSaldo, handleError } from '@/services/metal'
import { toRupiah } from '@/shared/utils'
export default {
  name: 'RequestIncentives',

  filters: {
    toRupiah: function(val) {
      return toRupiah(val)
    }
  }, // filters

  data() {
    return {
      partner: null,
      input: {
        amount: '',
        account_name: '',
        account_number: '',
        bank_name: 0,
      },
      bankNameOptions: [ { value: 0, text: 'Select Bank...'} ],
      storeState: store.state
    }
  }, // data

  async created() {
    store.setIsInitLoading(true)

    await getPartnerInfo()
      .then(response => {
        this.partner = response.data.data
      })
      .catch(error => {
        handleError(error)
      })

    await getAllBanks()
      .then(response => {
        response.data.data.forEach( data => {
          let bankNameOption = {
            value: data.id,
            text: data.name
          }
          this.bankNameOptions.push(bankNameOption)
        })
        store.setIsInitLoading(false)
      })
      .catch( error => {
        handleError(error)
      })
      .then( () => {
        store.clearProcessing()
      })
  }, // created

  methods: {
    submitRequestIncentives() {
      let reqData = {
        incentive_amount: this.input.amount,
        account_name: this.input.account_name,
        account_number: this.input.account_number,
        bank_id: this.input.bank_name,
      }

      requestIncentiveSaldo(reqData)
        .then( () => {
          window.scrollTo(0,0)
          store.showAlert('Request Incentive submitted successfully', 'success')
        })
        .catch( error => {
          handleError(error)
        })
        .then( () => {
          store.clearProcessing()
        })
    },
  }, // methods
}
</script>
